import * as angular from "angular";
import { DialogUtils } from "../../../../helper/dialog.helper";
import { ToastUtils } from "../../../../helper/toast.helper";
import { DashboardDataProvider } from "../../../../data-provider/dashboard.dp";
import { DashboardWidgetFilter } from "../../../../models/dashboard-widget-filter.model";
import { Dashboard } from "../../../../models/dashboard.model";

let WidgetFilterDialogComponent = {
    selector: "vcWidgetFilterDialog",
    templateUrl:
        "/angular/components/dashboard/widget/filter/widget-filter-dialog.component.html",
    bindings: {
        filter: "=?",
        title: "=?",
        dashboard: "=?",
        global: "=?",
    },
    controller: class WidgetFilterDialogController {
        // * bindings for typescript compiler *
        public filter: DashboardWidgetFilter;
        public title: string;
        public dashboard: Dashboard;
        // ************************************
        public saving: boolean = false;
        public dialog: DialogUtils;
        public toast: ToastUtils;
        public dataProvider: DashboardDataProvider;

        constructor(
            DashboardDataProvider: DashboardDataProvider,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.dataProvider = DashboardDataProvider;
        }

        $onInit() {
            if (!this.filter) {
                this.filter = new DashboardWidgetFilter();
            }
            if (!this.title) {
                this.title = "Report Filters";
            }
        }

        cancel() {
            this.dialog.cancel();
        }

        save() {
            this.dialog.hide(this.filter);
        }
    },
};

angular
    .module("dashboard")
    .component(
        WidgetFilterDialogComponent.selector,
        WidgetFilterDialogComponent
    );
